// extracted by mini-css-extract-plugin
export var textInput = "_lw-0";